export class MarketGroupsModel {
    constructor(data, leagueId) {
        this.id = data.id;
        this.outrightSortingKey = data.outrightSortingKey || "0";
        this.marketName = data.name;
        this.leagueId = leagueId;
        this.order = parseInt(this.outrightSortingKey);
        this.type = "marketGroups";
    }
    update(newItem) {
        this.updateMainModelItem(newItem);
        this.updateLeagueId(newItem);
        this.updateOutrightSortingKey(newItem);
        this.updateMarketName(newItem);
    }
    updateMainModelItem(newItem) {
        newItem.id && (this.id = newItem.id);
    }
    updateLeagueId(newItem) {
        newItem.leagueId && (this.leagueId = newItem.leagueId);
    }
    updateOutrightSortingKey(newItem) {
        if (newItem.outrightSortingKey) {
            this.outrightSortingKey = newItem.outrightSortingKey;
            this.order = parseInt(newItem.outrightSortingKey);
        }
    }
    updateMarketName(newItem) {
        newItem.marketName && (this.marketName = newItem.marketName);
    }
}
//# sourceMappingURL=MarketGroupsModel.js.map